import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useCallback, useEffect, useState } from "react";
import { FabrixIcon, translate } from "../../common";
import { useIcon } from "../../hooks";
import { JwtAuthService } from "../../services";
import CountDownClock from "../activity/count-down-clock";

export interface SessionWarningProps {
    open: boolean;
    onClose: (id: string) => void;

}

export function SessionWarning(props: SessionWarningProps) {

    const icon = useIcon();
    const [_open, setOpen] = useState<boolean>();
    //This is in seconds


    const silentLogin = async () => {
        let service = new JwtAuthService();
        await service.silentLogin();
    };

    const silentLogout = async () => {
        let service = new JwtAuthService();
        await service.logout();
    };



    const calcExpireDate = () => {
        // //Find out when the token will expire;
        let tokenExpiry = JwtAuthService.tokenExpiry();
        if (tokenExpiry) {
            return tokenExpiry;
        }
        else
            handleClose();
    };


    useEffect(() => {
        setOpen(props.open);

        if (props.open) {
        }
    }, [props.open]);

    const handleClose = async () => {
        await silentLogout();
        setOpen(false)
        props?.onClose("no");
    }



    const handleSave = async () => {
        await silentLogin();
        setOpen(false);
        props?.onClose("yes");
    }

    //When the timer reaches zero and the dialog is showing, we want to automatically close the dialog
    const handleZero = useCallback(() => {
        if (_open) {
            handleClose();
        }
    }, [_open]);


    return (
        <Dialog id="session-warning-dialog" visible={_open} style={{ width: '450px', height: '250px' }}
            contentClassName="flex flex-column" onHide={handleClose} showHeader={false} >
            <div className="flex flex-column flex-grow-1">
                <div className="flex flex-column flex-grow-1 justify-content-center align-items-center">
                    <p className="warning-paragraph">{translate("ARE_YOU_WORKING")}</p>

                    <CountDownClock active={_open} className="fbx-countdown-clock" time={calcExpireDate()} onZero={handleZero} />

                </div>
                <div className="warning-dialog-footer flex justify-content-center">
                    <Button label={translate("YES")} style={{ marginRight: 5 }} icon={icon(FabrixIcon.dialogSave)} onClick={handleSave} />
                </div>
            </div>

        </Dialog>

    );
}
